<template>
  <a
    class="manual-video-link"
    :href="url"
    target="_blank"
    rel="noopener noreferrer"
    title="使い方動画はこちら"
  >
    <v-icon class="manual-video-link__icon">mdi-play-circle</v-icon>
    <span class="manual-video-link__text">使い方動画はこちら</span>
    <v-icon class="manual-video-link__arrow">mdi-chevron-right</v-icon>
  </a>
</template>

<script>
import config from '@/config'

export default {
  computed: {
    url() {
      return config.manualVideoUrl
    }
  }
}
</script>

<style lang="stylus" scoped>
// MENUアイコン(72px)の右隣に絶対配置する。
// ヘッダーのロゴはleft:50%による中央寄せのため、通常のフローに要素を足すとロゴがずれてしまう。
.manual-video-link
  position absolute
  left 88px
  top 50%
  transform translateY(-50%)
  display flex
  align-items center
  padding 6px 16px
  border 2px solid #0d70e9
  border-radius 999px
  background #ffffff
  color #00348d
  font-size 15px
  font-weight bold
  line-height 1.0
  text-decoration none
  white-space nowrap
  transition box-shadow 0.3s
  font-feature-settings: "palt"

  &:hover
    box-shadow 0 0 0 3px rgba(13, 112, 233, .25)

  &__icon
    margin-right 8px
    color #fa1e32 !important
    font-size 28px !important

  &__arrow
    margin-left 6px
    color #0d70e9 !important
    font-size 22px !important

  // タブレット縦持ち相当。ロゴとの間隔を確保するため一回り小さくする
  @media screen and (max-width: 860px)
    padding 5px 12px
    font-size 13px

    &__icon
      margin-right 6px
      font-size 24px !important

    // VuetifyがCSSに .v-icon.v-icon と二重指定して詳細度を上げているため !important が要る
    &__arrow
      display none !important

  // 文字を出すとロゴに重なるためアイコンのみにする
  @media screen and (max-width: 560px)
    padding 5px 8px

    &__icon
      margin-right 0

    &__text
      display none

  // スマートフォン幅ではMENUとロゴの間が狭いため、さらに切り詰める
  @media screen and (max-width: 480px)
    left 72px
    padding 3px 5px
    border-width 1px

  // 375px未満はMENUとロゴの間が25px程度しかなく物理的に収まらないため非表示にする
  @media screen and (max-width: 374px)
    display none
</style>
